import { CAREERS_URL } from "../siteLinks";
import { Logo } from "./Logo";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-meta">
        <p>
          © {new Date().getFullYear()} Backbone Systems, Inc.
          <br />
          All rights reserved.
        </p>
        <nav aria-label="Footer" className="footer-links">
          <a href={CAREERS_URL} rel="noreferrer" target="_blank">
            Careers
          </a>
          <a href="/privacy">Privacy Policy</a>
        </nav>
      </div>
      <div className="footer-lockup">
        <Logo variant="display" />
      </div>
    </footer>
  );
}
